import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'inside-out/components/shared/link';
import { wrapperStyle } from './styles';

const LinkListComponent = ({ links }) => (
	// TODO: nav / div switch
	<nav className={wrapperStyle}>
		{(Array.isArray(links) ? links : [links]).map(link => (
			<Link key={link.to} to={link.to}>
				{link.text}
			</Link>
		))}
	</nav>
);

LinkListComponent.propTypes = {
	links: PropTypes.any,
};

export const LinkList = LinkListComponent;



// WEBPACK FOOTER //
// ./src/components/shared/linkList/component.js